"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedWarningIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme");
const RedWarningIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "15", height: "15", viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.49997 14.517C11.3754 14.517 14.517 11.3754 14.517 7.5C14.517 3.62462 11.3754 0.483002 7.49997 0.483002C3.62459 0.483002 0.482971 3.62462 0.482971 7.5C0.482971 11.3754 3.62459 14.517 7.49997 14.517ZM6.64368 9.35471H8.38822L8.663 2.9964H6.3689L6.64368 9.35471ZM6.64368 10.5625C6.41789 10.7627 6.30499 11.0204 6.30499 11.3357C6.30499 11.6509 6.41789 11.9108 6.64368 12.1153C6.87373 12.3155 7.15916 12.4157 7.49997 12.4157C7.84079 12.4157 8.12409 12.3155 8.34988 12.1153C8.57993 11.9108 8.69495 11.6509 8.69495 11.3357C8.69495 11.0204 8.57993 10.7627 8.34988 10.5625C8.12409 10.358 7.84079 10.2557 7.49997 10.2557C7.15916 10.2557 6.87373 10.358 6.64368 10.5625Z", fill: Theme_1.theme.palette.UI_WARNING })));
};
exports.RedWarningIcon = RedWarningIcon;
